export const location = {
  center: [37.649905, 47.123617],
  zoom: 12,
};

